import { Field, Form, Label } from "@kanda-libs/ks-component-ts";
import {
  Button,
  ModalContainer,
  ModalLayoutCenter,
  Separator,
} from "@kanda-libs/ks-design-library";
import { AlertBanner } from "@kanda-libs/ks-design-library-new";
import CidLookupInput from "components/shared/CidLookupInput";
import type { FunctionComponent, MutableRefObject } from "react";
import { MODAL_ID } from "./constants";
import useCreateJobFromLeadModalForm from "./useCreateJobFromLeadModalForm";

export interface CreateJobFromLeadModalProps {
  onCreateJobFromLead: (cid: string) => void;
}

const CreateJobFromLeadModal: FunctionComponent<CreateJobFromLeadModalProps> =
  function ({ onCreateJobFromLead }) {
    const { form, isSubmitting, onSubmit, hasQuote, onChangeCid } =
      useCreateJobFromLeadModalForm(onCreateJobFromLead);

    return (
      <ModalContainer id={MODAL_ID} opacity={30}>
        {({ handleClose }) => (
          <>
            <ModalLayoutCenter
              id="staff-revert-job-modal"
              onClose={() => {
                handleClose();
              }}
              className="w-10/12 md:w-160 min-h-80"
            >
              <>
                {!hasQuote && (
                  <div className="mt-8">
                    <AlertBanner>
                      This customer has not yet sent the job details for this
                      lead
                    </AlertBanner>
                  </div>
                )}
                {hasQuote && (
                  <>
                    <Form
                      id="staff-create-job-from-lead"
                      form={form}
                      onSubmit={onSubmit}
                    >
                      <Label label="Company lookup" />
                      <CidLookupInput onChange={onChangeCid} />
                      <div className="my-5 text-center text-neutral-600">
                        Lookup a company OR enter the CID
                      </div>
                      <Field.Input
                        name="cid"
                        label="Company ID (cid)"
                        placeholder="e.g: 0edeed3e-1aac-4576-a839-0e3c4f209f06"
                      />
                      <Button.Text
                        submit
                        id="staff-create-job-from-lead"
                        label="Create job from lead"
                        isLoading={isSubmitting}
                      />
                    </Form>
                  </>
                )}
              </>
            </ModalLayoutCenter>
          </>
        )}
      </ModalContainer>
    );
  };

export default CreateJobFromLeadModal;
